"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var key_codes_enum_1 = require("./../validators/key-codes.enum");
var NumberOnlyDirective = (function () {
    function NumberOnlyDirective(elementReference, renderer, ngFormControl, control) {
        this.elementReference = elementReference;
        this.renderer = renderer;
        this.ngFormControl = ngFormControl;
        this.control = control;
        this.isUserDeleting = null;
    }
    Object.defineProperty(NumberOnlyDirective.prototype, "numberRegExPattern", {
        // finds all non-numeric characters.
        get: function () {
            return /[^\d]/gi;
        },
        enumerable: true,
        configurable: true
    });
    NumberOnlyDirective.prototype.onUserFocus = function (event) {
        this.onFocusInputValue = event.target.value;
    };
    NumberOnlyDirective.prototype.onUserKeyUp = function (event) {
        this.isUserDeleting = event && event.which && (event.which === key_codes_enum_1.KeyCodes.backspace || event.which === key_codes_enum_1.KeyCodes.delete);
    };
    NumberOnlyDirective.prototype.onUserInput = function (event) {
        // track the input
        var inputElement = event.target;
        // grab the current value of the input.
        var newValue = inputElement.value;
        var formattedNewValue = newValue.replace(this.numberRegExPattern, '');
        if (formattedNewValue !== newValue) {
            // we need to update the input's value.
            // calculate the new cursor position BEFORE setting the updated value.
            var newCursorPosition = inputElement.selectionStart - (newValue.length - formattedNewValue.length);
            if (newCursorPosition < 0) {
                newCursorPosition = 0;
            }
            // update the input's value.
            this.updateInput(formattedNewValue, inputElement);
            // reset the user's cursor, if necessary, AFTER the value is set.
            inputElement.selectionStart = newCursorPosition;
            inputElement.selectionEnd = newCursorPosition;
        }
    };
    NumberOnlyDirective.prototype.updateInput = function (newValue, inputElement) {
        // update the value of the input element.
        // this will be done whether there are validation controls are not.
        this.renderer.setElementProperty(inputElement, 'value', newValue);
        // find the control to use to update the value.
        // controls only exist if the developer put one on the element.
        var controlToUpdate = null;
        if (this.control) {
            controlToUpdate = this.control;
        }
        else if (this.ngFormControl) {
            controlToUpdate = this.ngFormControl.control;
        }
        if (controlToUpdate) {
            // if we have a control on the element, we need to update its value.
            controlToUpdate.setValue(newValue);
            //  this will tell the control to revalidate based on the value we programatically set into the input.
            controlToUpdate.updateValueAndValidity();
        }
    };
    return NumberOnlyDirective;
}());
NumberOnlyDirective = __decorate([
    core_1.Directive({
        selector: '[number-only], [ngControl] [number-only], [number-only] [ngControl], [ngFormControl] [number-only], [number-only] [ngFormControl]',
        host: {
            '(focus)': 'onUserFocus($event)',
            '(input)': 'onUserInput($event)',
            '(keyup)': 'onUserKeyUp($event)'
        }
    }),
    __param(2, core_1.Optional()),
    __param(3, core_1.Optional()),
    __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer,
        forms_1.NgControl,
        forms_1.FormControl])
], NumberOnlyDirective);
exports.NumberOnlyDirective = NumberOnlyDirective;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/custom-directives/number-only.directive.js